import fragment from 'graphql/fragments/product/DeadStockFragment.graphql';

import workspaceQuery from 'graphql/queries/product/DeadStockWorkspaceQuery.graphql';
import instanceQuery from 'graphql/queries/product/DeadStockQuery.graphql';
import { ALLOW_EDIT, ALLOW_VIEW } from '../../../utils/OperationPermissions';
import { document } from '../../../utils/mailMergeFields';

const DeadStock = {
  type: 'DeadStockRangeInput',
  title: 'Dead Stock',
  formUrl: '/Products/PrintDeadStock/',
  formTitle: 'Dead Stock',
  workspaceUrl: '/Products/DeadStock/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  fragment,
  reportType: 'DEAD_STOCK',
  documentName: 'DEAD_STOCK',
  screenReference: 'PRODUCT_DEAD_STOCK',
  operations: ALLOW_EDIT | ALLOW_VIEW,
  mergeFields: document,
};

export default DeadStock;
